import React from 'react'

export default function Footer() {
    return (
        <div>
                <footer className="footer d-flex flex-column flex-md-row align-items-center justify-content-between px-4 py-3 border-top small">
                    <p className="text-muted mb-1 mb-md-0">Copyright © {new Date().getFullYear()} <a href="https://macrohealthplus.org" target="_blank">MHP POS</a> All rights reserved.</p>
                    <p className="text-muted">Developed by <a href="https://macrohealthplus.org" target="_blank">MacroHealthPlus</a> <i className="mb-1 text-primary ms-1 icon-sm" data-feather="heart" /></p>
                </footer>
        </div>
    )
}
